import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './helpers/axios';

// Register the global axios 401 interceptor — must be imported before any
// component makes API calls so expired-token responses are always caught.
// import './helpers/axios';

// Suppress benign ResizeObserver loop notifications in browser/dev-server
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded' ||
    (e.message && e.message.includes('ResizeObserver')) ||
    (e.message && e.message.includes('Cannot convert object to primitive value')) ||
    (e.message && e.message.includes('Cannot read properties of null (reading \'focus\')'))
  ) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
    return true;
  }
});
window.addEventListener('unhandledrejection', (e) => {
  if (
    e.reason?.message?.includes('ResizeObserver') ||
    e.reason?.message?.includes('Cannot convert object to primitive value') ||
    e.reason?.message?.includes('Cannot read properties of null (reading \'focus\')')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from './state/store';
import '@vueform/multiselect/themes/default.css';

import Layout from '@/layouts/main.vue';
import PageHeader from '@/components/page-header';
import BookToTransportModal from '@/components/BookToTransportModal.vue';
import FindContactModal from '@/components/FindContactModal.vue';

import '@/helpers/ag-grid-enterprise';
import '@/helpers/ag-grid-enterprise/styles/ag-grid.css';
import '@/helpers/ag-grid-enterprise/styles/ag-theme-alpine.css';

import { AgGridVue } from 'ag-grid-vue3';
import '@/helpers/agGridVuePatch';

import BootstrapVue3, { vBTooltip } from 'bootstrap-vue-3';
import vClickOutside from 'click-outside-vue3';
import VueApexCharts from 'vue3-apexcharts';
import Maska from 'maska';

import VueFeather from 'vue-feather';
import flatPickr from 'vue-flatpickr-component';
import Multiselect from '@vueform/multiselect';
import '@/assets/scss/config/default/app.scss';

import '@vueform/slider/themes/default.css';
import '@/assets/scss/mermaid.min.css';
import { abilitiesPlugin } from '@casl/vue';
import { Ability } from '@casl/ability';

const ability = new Ability();

import '@/assets/scss/myStyle.css';

import { surveyPlugin } from 'survey-vue3-ui';
import { surveyCreatorPlugin } from 'survey-creator-vue';

import 'survey-core/survey.i18n.js';
import 'survey-core/defaultV2.css';
import 'survey-creator-core/survey-creator-core.css';

import Vue3FormWizard from 'vue3-form-wizard';
import 'vue3-form-wizard/dist/vue3-form-wizard.css';

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);


AOS.init({
  easing: 'ease-out-back',
  duration: 1000
});

const app = createApp(App);

app.config.warnHandler = (msg, instance, trace) => {
  try {
    const traceStr = trace ? `\n${trace}` : '';
    console.warn(`[Vue warn]: ${msg}${traceStr}`);
  } catch (_) {
    // Suppress console wrapper serialization errors
  }
};

app
  .use(store)
  .use(router)
  .component('Layout', Layout)
  .component('PageHeader', PageHeader)
  .component('BookToTransportModal', BookToTransportModal)
  .component('FindContactModal', FindContactModal)
  .component('AgGridVue', AgGridVue)
  .component('Multiselect', Multiselect)
  .component(VueFeather.type, VueFeather)
  .component('flatPickr', flatPickr)
  .use(Vue3FormWizard)
  .use(VueApexCharts)
  .use(BootstrapVue3)
  // BootstrapVue removes the native title after its first update. Its tooltip
  // directive then calls toString() on an omitted directive value during a
  // later component update, even when a static title attribute was supplied.
  // Restore that stored title before delegating to the library directive.
  .directive('b-tooltip', {
    beforeMount(el, binding) {
      if (!el.getAttribute('title') && binding.value == null) el.setAttribute('title', '');
      vBTooltip.beforeMount(el, binding);
    },
    updated(el, binding) {
      if (!el.getAttribute('title') && binding.value == null) {
        el.setAttribute('title', el.getAttribute('data-bs-original-title') || '');
      }
      vBTooltip.updated(el, binding);
    },
    unmounted(el) {
      vBTooltip.unmounted(el);
    },
  })
  .use(Maska)
  .use(i18n)
  .use(vClickOutside)
  .use(abilitiesPlugin, ability, {
    useGlobalProperties: true
  })
  .use(surveyPlugin)
  .use(surveyCreatorPlugin)
  .directive('uppercase', {
    updated(el) {
      el.value = el.value.toUpperCase();
      el.dispatchEvent(new Event('input')); // to trigger v-model update
    }
  })
  .mount('#app');
